import './index.css'
export default function HomePage() {

  return (
    <>
        <div className="home-page">
        <span>---------HOMEPAGE-----------</span>
            <h1>Welcome to softyeducation </h1>
            <h3>PACK PFE 😍👨‍💻</h3>
        </div>
    </>
  )
}